import styled from 'styled-components'
import Icon from './Icon'

export default styled(Icon).attrs({
  type: 'circle-exclam',
})``
